import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmojiU1f4cbIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmojiU1f4cbIcon = ({ className, ...props }: EmojiU1f4cbIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.20386 19.6367L17.5159 2.75516C17.9679 2.75516 18.7964 2.79641 18.7964 3.91359V20.1609C18.7964 20.613 18.4303 20.9791 17.9782 20.9791H4.1973C3.74526 20.9808 3.20386 20.5752 3.20386 19.6367Z"
      fill="#A15D38"
    />
    <path
      d="M3.20386 19.6591V3.53031C3.20386 3.09891 3.55276 2.75 3.98417 2.75H17.4901C17.9215 2.75 18.2704 3.09891 18.2704 3.53031V19.6591C18.2704 20.0905 17.9215 20.4394 17.4901 20.4394H3.98417C3.55276 20.4394 3.20386 20.0905 3.20386 19.6591Z"
      fill="#BA793E"
    />
    <path
      d="M4.88989 18.8478V4.30032C4.88989 4.0786 5.07036 3.89813 5.29208 3.89813H16.3643C16.586 3.89813 16.7665 4.0786 16.7665 4.30032V18.8478C16.7665 19.0695 16.586 19.25 16.3643 19.25H5.29208C5.07036 19.25 4.88989 19.0713 4.88989 18.8478Z"
      fill="white"
    />
    <path
      d="M6.64331 9.34312H15.0136"
      stroke="#B0BEC5"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.515625"
    />
    <path
      d="M6.64319 7.37515H15.0135"
      stroke="#B0BEC5"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.515625"
    />
    <path
      d="M6.64331 11.3111H15.0136"
      stroke="#B0BEC5"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.515625"
    />
    <path
      d="M6.64331 13.2808H15.0136"
      stroke="#B0BEC5"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.515625"
    />
    <path
      d="M6.64331 15.2488H15.0136"
      stroke="#B0BEC5"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.515625"
    />
    <path
      d="M6.64331 17.2167H10.2235"
      stroke="#B0BEC5"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.515625"
    />
    <path
      d="M14.9411 4.88125V2.75516H12.5383L14.0354 4.88125H14.9411Z"
      fill="#212121"
      opacity="0.35"
    />
    <path
      d="M13.4084 2.83422L12.855 2.82562C12.4872 2.82562 12.4184 2.49906 12.4047 2.43031C12.3858 2.34094 12.3617 2.14328 12.3514 2.06422C12.2586 1.2925 11.9939 0.818123 11.0297 0.708123C10.1944 0.613592 9.59453 1.47125 9.59453 2.28937C9.59453 2.29109 9.59453 2.29453 9.59453 2.29625C9.59625 2.66578 9.31609 2.97515 8.94656 2.97515C8.94656 2.97515 7.86718 2.79125 7.09546 3.67469C6.95109 3.83969 6.77749 4.52031 6.77578 4.71109C6.77234 5.24219 7.23125 5.31265 7.39109 5.31437C8.10953 5.31953 13.9619 5.30062 14.5222 5.30062C14.7525 5.30062 14.9398 5.11328 14.9398 4.88297V4.57187C14.9416 3.68844 14.2902 2.83422 13.4084 2.83422ZM10.9816 2.88062C10.6636 2.88062 10.4058 2.62281 10.4058 2.30484C10.4058 1.98687 10.6636 1.72906 10.9816 1.72906C11.2995 1.72906 11.5573 1.98687 11.5573 2.30484C11.5573 2.62281 11.2995 2.88062 10.9816 2.88062Z"
      fill="#2F7889"
    />
    <path
      d="M13.0937 2.74827H12.7602C12.3924 2.74827 12.2446 2.45952 12.1982 2.35983C12.1312 2.21374 12.1123 1.9164 12.1002 1.83733C12.004 1.23062 11.4969 0.749366 10.8868 0.684053C10.0515 0.592959 9.34334 1.24608 9.34334 2.06249C9.34334 2.06421 9.34334 2.06765 9.34334 2.06937C9.34506 2.4389 9.06491 2.74827 8.69538 2.74827H8.36881C7.48709 2.74827 6.77209 3.46327 6.77209 4.34499V4.65608C6.77209 4.8864 6.95944 5.07374 7.18975 5.07374H14.271C14.5013 5.07374 14.6887 4.8864 14.6887 4.65608V4.34499C14.6904 3.46327 13.9754 2.74827 13.0937 2.74827ZM10.7304 2.65546C10.4124 2.65546 10.1546 2.39765 10.1546 2.07968C10.1546 1.76171 10.4124 1.5039 10.7304 1.5039C11.0483 1.5039 11.3062 1.76171 11.3062 2.07968C11.3062 2.39765 11.0483 2.65546 10.7304 2.65546Z"
      fill="#82AEC0"
    />
    <path
      d="M13.5733 3.78812H7.71578C7.49235 3.78812 7.43391 3.66265 7.54907 3.47187C7.7175 3.19515 8.11969 3.01297 8.46344 3.01297C9.20938 3.01297 11.9009 2.93047 12.848 2.93047C13.3103 2.93047 13.5509 3.08515 13.752 3.34297C13.8947 3.52859 13.8053 3.78812 13.5733 3.78812Z"
      fill="#B9E4EA"
    />
    <path
      d="M9.79382 1.62937C9.89007 1.2375 10.2596 1.12578 10.2596 1.12578"
      stroke="#B9E4EA"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.363773"
    />
  </svg>
);

export default EmojiU1f4cbIcon;
